import { render } from "./AccountMode.vue?vue&type=template&id=47035fe3&scoped=true"
import script from "./AccountMode.vue?vue&type=script&lang=js"
export * from "./AccountMode.vue?vue&type=script&lang=js"

import "./AccountMode.vue?vue&type=style&index=0&id=47035fe3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47035fe3"]])

export default __exports__